
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  getRelationPaymentVoucher,
  removeRelation,
  addRelation,
} from "@/api/supplier-payment";
import { COMPANY_LIST } from "@/constant";
import { searchCustomer } from "@/api/customer";

@Component({
  name: "CreateFee",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "选择付款单" }) private title: "";
  @Prop({ default: "" }) private id: "";
  @Prop({ default: "" }) private supplierId: "";

  @Watch("supplierId", { immediate: true })
  private async watchData() {
    if (this.supplierId) {
      await this.getRelationPaymentVoucher();
    }
  }

  private form = {
    customerId: null,
    company: null,
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "付款类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false,
    },
    {
      label: "单据剩余",
      prop: "paymentRemaining",
      key: "paymentRemaining",
      show: true,
      disabled: false,
    },
    {
      label: "本次使用",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 2
    },
  ] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change",
      },
      options: COMPANY_LIST,
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change",
      },
      labelKey: "abbreviation",
      valueKey: "id",
    },
  ];
  private options = [];
  private value = "";

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }
  public loading: Boolean = false;
  private async getRelationPaymentVoucher() {
    this.loading = true;
    const res: any = await getRelationPaymentVoucher({
      supplierId: this.supplierId,
    });
    this.table.list = res;
    this.loading = false;
  }

  //  删除
  public async handleDelete(scope) {
    await removeRelation(scope.row.id);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.$emit("success", false);
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }

  private handleAdd() {
    // table.list 新增一条记录
    this.table.list.push({
      type: "",
      amount: "",
      remark: "",
    });
  }

  private async inputChange({ val, row, column }) {
    console.log(column.key);
    const { paymentRemaining, useAmount } = row.row;
    if (useAmount > paymentRemaining) {
      this.$set(row.row, "useAmount", paymentRemaining);
    }
  }

  private async submitForm() {
    if (!this.selectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择付款单",
        type: "error",
        duration: 2000,
      });
      return;
    }
    // 判断this.selectedRows中useAmount是否填写
    let flag = false;
    this.selectedRows.forEach((item) => {
      if (!item.useAmount) {
        flag = true;
      }
    });
    if (flag) {
      this.$notify({
        title: "提示",
        message: "请填写本次使用",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.$emit("submit", this.selectedRows);
    this.selectedRows = [];
    (this.$refs.table as any).$refs.table.clearSelection();
    this.close();
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }

  private async addRelation() {
    let params = {
      relationId: this.value,
      userAmount: this.options.find((item) => item.id === this.value)
        .paymentRemaining,
    };
    try {
      await addRelation(this.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.value = "";
      this.$emit("success", false);
    } catch {}
  }
}
